import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { ReactNode } from 'react';

export const MaskContainer = styled.div<{
  children?: ReactNode;
}>`
  position: absolute;
  width: 0;
  height: 0;
`;
export const HeaderContainer = styled.div<{
  children?: ReactNode;
}>`
  width: 100%;
  min-height: 630px;
`;

export const HeaderInnerContainer = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  flex-grow: 1;
  &.type-story {
    background: #f4f4f4;
  }
  &.type-blue {
    background: #E6E7EE;
  }
  &.type-peach {
    background: #FAF3ED;
  }
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 10;
  @media screen and (max-width: 1023px) {
    flex-wrap: wrap;
  }
  @media screen and (max-width: 767px) {
    min-height: 100px;
    padding: 50px 0;
  }

`;
export const HeaderTextArea = styled.div<{
  children?: ReactNode;
}>`
  width: 100%;
  display: flex;
  height: 100%;
  align-items: flex-start;
  justify-content: left;
  flex-flow: column;
  max-width: 540px;
  margin: 0 auto;
  text-align: left;

  margin: 0 auto;
  text-align: left;
  @media screen and (min-width: 768px) {
    padding-bottom: 60px;
  }
  @media screen and (max-width: 1300px) {
    width: 45%;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
  }
  h1 {
    color: #010e54;
  }
  p {
    color: #010e54;
  }
`;
export const ImageArea = styled.div<{
  children?: ReactNode;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 505px;
  height: 329px;
  overflow: hidden;
  img {
    border-radius: 16px;
    max-height: 100%;
    width: auto;
  }
  @media screen and (max-width: 1300px) {
    width: 45%;
  }
  @media screen and (max-width: 767px) {
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
  }
`;
export const HeaderContainerFlex = styled.div<{
  children?: ReactNode;
}>`
  width: 90%;
  max-width: 1400px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-flow: row;
  margin: 0 auto;
  @media screen and (max-width: 767px) {
    display: block;
    text-align: center;
  }
  @media screen and (min-width: 480px) and (max-width: 787px) {
    padding-bottom: 100px;
  }
  @media screen and (min-width: 768px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }

`;

export const ButtonVideo = styled.div<{
  children?: ReactNode;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    margin-right: 10px;
  }
`;
export const CategoryBox = styled.div<{
  children?: ReactNode;
}>`
  background: #010e54;
  border-radius: 100px;
  padding: 8px 20px 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  p {
    color: #fff;
  }
  @media screen and (max-width: 767px) {
    display: block;
    margin: 0 auto;
  }
`;

const TWBackground = tw.div`
  md:mb-20
`;

export const MaskBottom = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    min-height: 630px;
  }

`;

export const Background = styled(TWBackground)<{
  $customColor: string;
  children?: ReactNode;
  className?: string;
}>`
  position: relative;
  padding-bottom: 40px;
  margin-bottom: 20px;
  ${({ $customColor }) => ($customColor ? `background-color: ${$customColor};` : '')}
  overflow-x: hidden;
  z-index: -1;
  width: 100%;
`;
